/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { foundryPlatformFetch as $foundryPlatformFetch } from "@osdk/shared.net.platformapi";
//
const _list = [0, "/v2/ontologies/{0}/actionTypesFullMetadata", 2];
/**
 * Lists the action types (with full metadata) for the given Ontology.
 *
 * Each page may be smaller than the requested page size. However, it is guaranteed that if there are more
 * results available, at least one result will be present in the response.
 *
 * @alpha
 *
 * Required Scopes: [api:ontologies-read]
 * URL: /v2/ontologies/{ontology}/actionTypesFullMetadata
 */
export function list($ctx, ...args) {
    return $foundryPlatformFetch($ctx, _list, ...args);
}
const _get = [0, "/v2/ontologies/{0}/actionTypes/{1}/fullMetadata", 2];
/**
 * Gets the full metadata associated with an action type.
 *
 * @alpha
 *
 * Required Scopes: [api:ontologies-read]
 * URL: /v2/ontologies/{ontology}/actionTypes/{actionType}/fullMetadata
 */
export function get($ctx, ...args) {
    return $foundryPlatformFetch($ctx, _get, ...args);
}
